import React from "react";
import PolicyPage from "./PolicyPage";
import { policies } from "../Datas/policyData";

function Terms() {
  return <PolicyPage policy={policies.terms} />;
}

export default Terms;
